var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"EventDetail"},[(_vm.icon)?_c('UiIcon',{attrs:{"width":22,"height":22,"name":_vm.icon}}):_vm._e(),_c('dl',{staticClass:"EventDetail__datalist"},[_c('dt',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('dd',{staticClass:"m-2"},[_vm._v(" "+_vm._s(_vm.description ?? '-')+" "),_vm._t("action")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }